import {navigateTo, useMaltEnvironnement, useRoute, useRouter, useRuntimeConfig} from '#imports';
import {safelyNavigateTo} from '@malt/utils';
import {useGetCurrentServerName} from '../internals/serverUtils';

function stripTrailingSlash(path: string) {
    return path.replace(/\/$/, '');
}

/** In dev mode, use the independent login page when it is registered (via common-components).
 *  Otherwise — and in production — redirect to the Malt host login page.
 */
function useRedirectToSignIn(redirect?: string) {
    const route = useRoute();
    const router = useRouter();
    const config = useRuntimeConfig();
    const currentHost = useGetCurrentServerName();
    const maltEnvironnement = useMaltEnvironnement();

    const currentRoute = `${stripTrailingSlash(config.app.baseURL)}${route.fullPath}`;
    const query = {redirect: route.name === 'Signin' ? undefined : redirect || currentRoute};

    if (process.dev && maltEnvironnement === 'DEV') {
        if (!router.hasRoute('Signin')) {
            throw new Error('Route "Signin" is not registered. Install @malt/nuxt-common-components-module on this app to enable it.');
        }

        const backendUrl = config.public.backendUrl ?? '/';
        const pathPrefix = config.app.baseURL === '/' ? backendUrl : '';

        return navigateTo({path: `${stripTrailingSlash(pathPrefix)}/signin`, query});
    } else {
        return safelyNavigateTo({path: currentHost + '/signin', query}, {externalToThisApp: true});
    }
}

export {useRedirectToSignIn as redirectToSignIn};
